
module.exports = {

  ROOT_ITEM: {
    id: -1,
    text: 'root',
    expanded: true,
    root: true
  },


}



// WEBPACK FOOTER //
// ./src/deni-react-treeview/deni-react-treeview.constant.js